import React from 'react'
import SelectorElement from '../../components/SelectElement'
import CardElement from '../../components/card.v2'
import { useFormikContext } from 'formik'
import { LayoutWithAvatar } from '../gender/gender'
import { HoverBorderGradientDemo } from '../../components/Button'

const Traits = ({ currentStep, setCurrentStep }) => {
  const { values, setFieldValue } = useFormikContext()

  const handleInputChange = (value, e) => {
    setFieldValue(`traits`, value)
  }

  return (
    <LayoutWithAvatar>
      {/* Left Section */}
      <div className='col-span-2 max-w-sm mx-auto md:col-span-1 flex items-center gap-20 justify-center'>
        <div className='relative'>
          <CardElement fixHeight>
            <h2 className='text-gray-700 font-semibold mb-4 cursor-pointer'>
              <svg
                onClick={() => {
                  setCurrentStep(currentStep - 1)
                }}
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth='2'
                stroke='currentColor'
                className='w-5 h-5'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M15 19l-7-7 7-7'
                />
              </svg>
            </h2>
            <h2 className='text-gray-700 font-semibold mb-4 text-lg'>
              Personality Traits:
            </h2>
            <div className='flex  max-h-[170px] custom-scrollbar overflow-auto flex-col gap-7 mt-6'>
              <SelectorElement
                icon={'/images/outgoing.png'}
                label={'Outgoing'}
                active={values.traits === 'Outgoing'}
                onChange={handleInputChange}
              />
              <SelectorElement
                icon={'/images/empathetic.png'}
                label={'Empathetic'}
                active={values.traits === 'Empathetic'}
                onChange={handleInputChange}
              />
              <SelectorElement
                icon={'/images/sassy.png'}
                label={'Sassy'}
                active={values.traits === 'Sassy'}
                onChange={handleInputChange}
              />
              <SelectorElement
                icon={'/images/southern.png'}
                label={'Southern Charm'}
                active={values.traits === 'Southern Charm'}
                onChange={handleInputChange}
              />
            </div>
            <div className='mt-8'>
              <HoverBorderGradientDemo
                type='button'
                onClick={() => {
                  setCurrentStep(currentStep + 1)
                }}
                disabled={!values?.gender}
              >
                <span className='font-bold capitalize'>Select</span>
              </HoverBorderGradientDemo>
            </div>
          </CardElement>
        </div>
      </div>
      {/* Right Section */}
      <div className='hidden col-span-1 md:flex items-center justify-center relative'>
        <div>
          <video
            src={`/videos/3rd-female.webm`}
            style={{
              filter: values.gender == 'Female' ? '' : 'hue-rotate(270deg)',
            }}
            autoPlay
            loop
            className='w-full h-full'
          />
        </div>
      </div>
    </LayoutWithAvatar>
  )
}

export default Traits
